import React, { useEffect, useState } from 'react';
import Loader from '@components/Loader';
import { Error500Icon } from '@icons';
import './PlaybackPreparingLoader.less';

// Loads finishing faster than this show no loader, so switching quickly
// between media does not flash it
export const DELAYED_LOADER_MS = 300;
// While the previous asset's image or video frame is still on screen
export const PREVIOUS_MEDIA_LOADER_DELAY_MS = 1000;

interface PlaybackPreparingLoaderProps {
  isVideo?: boolean;
  error?: boolean;
  /** Override the default message. Falls back to the preparing-preview /
   * preparing-for-playback copy if omitted. */
  message?: React.ReactNode;
  /** Show only if still mounted after a short delay (plain loading states) */
  delayed?: boolean;
  delayMs?: number;
}

function PlaybackPreparingLoader({
  isVideo,
  error,
  message,
  delayed = false,
  delayMs = DELAYED_LOADER_MS
}: PlaybackPreparingLoaderProps) {
  const [isVisible, setIsVisible] = useState(!delayed);

  useEffect(() => {
    if (!delayed) return;
    const timeout = setTimeout(() => setIsVisible(true), delayMs);
    return () => clearTimeout(timeout);
  }, [delayed, delayMs]);

  // Errors are shown right away
  if (!isVisible && !error) return null;

  const copy =
    message ?? (isVideo ? 'Preparing for playback...' : 'Preparing preview...');

  return (
    <div className="media_viewer_playback_container">
      <div className="media_viewer_playback_container__content">
        {!error && (
          <Loader spinSize={72} isSpinning={true} classNameWrapper="loader" />
        )}
        {error && <Error500Icon style={{ fontSize: '128px' }} />}
        <div className="copy">{copy}</div>
      </div>
    </div>
  );
}

export default PlaybackPreparingLoader;
